import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, Transition as _Transition, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "modal__header" }
const _hoisted_2 = { class: "modal__wrap-info-header" }
const _hoisted_3 = {
  key: 1,
  class: "modal__title"
}
const _hoisted_4 = { class: "modal__content" }
const _hoisted_5 = {
  key: 1,
  class: "modal__footer"
}

import { computed, PropType, ref, useSlots, onUnmounted } from "vue";
import { ArrowLeftIcon, XMarkIcon } from "tir-style-system/icons/solid";
import { TirPmScrollbar } from "tir-pm-scrollbar";
import { TirPmModalAlignEnum } from "./enums";

/**Параметры */

export default /*#__PURE__*/_defineComponent({
  __name: 'TirPmModal',
  props: {
  /**Видимость */
  isVisible: { type: Boolean as PropType<boolean>, default: false },
  /** Показывать ли кнопку назад */
  isWithBack: { type: Boolean as PropType<boolean>, default: true },
  /** Закрывать ли по клику */
  isCloseOverlay: { type: Boolean as PropType<boolean>, default: false },
  /** Положение */
  align: {
    type: String as PropType<TirPmModalAlignEnum>,
    default: TirPmModalAlignEnum.Center,
  },
  /**Заголовок */
  title: { type: String as PropType<string>, default: "" },
  /**Делает кнопку "назад" считалкой стпов внутри конктентной части */
  isWithStep: { type: Boolean as PropType<boolean>, default: false },
  /** Текущий номер шага */
  numberStep: { type: Number as PropType<number>, default: 0 },
  /** Показывать ли кнопку закрытия */
  isWithCloseButton: { type: Boolean as PropType<boolean>, default: true },
  /**Классы для modal элемента */
  classes: { type: String, default: "" },
},
  emits: ["close", "open", "backStep"],
  setup(__props, { emit }) {

const props = __props;


/**События */


const closeModal = ref(false);
/**DOM элемент блока с классом modal */
const $content = ref<HTMLElement>();
/**При закрытии */
const onClose = () => {
  emit("close");
};
/**При закрытии на оверлее */
const onCloseFromOverlay = (e: MouseEvent | TouchEvent) => {
  // closeModal.value = true;

  if (props.isCloseOverlay) {
    const $target = e.target as HTMLElement;
    if (
      !$content.value ||
      !$target ||
      $target == $content.value ||
      $content.value.contains($target)
    ) {
      return;
    } else {
      closeModal.value = true;
    }
    setTimeout(() => {
      emit("close");
      closeModal.value = false;
    }, 0.2);
  }
};

/** К предыдущему шагу */
const toBackStep = () => {
  if (props.numberStep !== 0) {
    emit("backStep");
  } else {
    emit("close");
  }
};
/**Видимость */
const visible = computed(() => props.isVisible);
/**Слоты */
const slots = useSlots();
/**Есть ли дефолный футер */
const isFooter = computed(() => slots && slots.footer && slots.footer());

const isContent = computed(() => slots && slots.content && slots.content());
/**Если слот под заголовок */
const isTitleSlot = computed(() => slots && slots.title && slots.title());

onUnmounted(() => {
  if (visible.value) {
    emit("close");
    document.body.style.removeProperty("overflow");
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "modal-visible" }, {
      default: _withCtx(() => [
        (__props.isVisible)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["modal-overlay", {
          'modal-overlay--modal-right': props.align == _unref(TirPmModalAlignEnum).Right,
          'modal-hide': closeModal.value && props.align == _unref(TirPmModalAlignEnum).Right,
        }]),
              onClick: onCloseFromOverlay
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["modal", __props.classes]),
                ref_key: "$content",
                ref: $content
              }, [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, [
                    (props.isWithBack)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "modal__back-button",
                          onClick: _cache[0] || (_cache[0] = () => (props.isWithStep ? toBackStep() : onClose()))
                        }, [
                          _createVNode(_unref(ArrowLeftIcon)),
                          _createTextVNode(" Назад ")
                        ]))
                      : _createCommentVNode("", true),
                    (props.title || isTitleSlot.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                          _renderSlot(_ctx.$slots, "title", {}, () => [
                            _createTextVNode(_toDisplayString(props.title), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (props.isWithCloseButton)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "modal__close-button",
                        onClick: onClose
                      }, [
                        _createVNode(_unref(XMarkIcon))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (isContent.value)
                  ? (_openBlock(), _createBlock(_unref(TirPmScrollbar), {
                      key: 0,
                      class: "modal__content-scroll"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_4, [
                          _renderSlot(_ctx.$slots, "content")
                        ])
                      ]),
                      _: 3
                    }))
                  : _createCommentVNode("", true),
                (isFooter.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _renderSlot(_ctx.$slots, "footer")
                    ]))
                  : _createCommentVNode("", true)
              ], 2)
            ], 2))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ]))
}
}

})